const n = "_container_1pgra_1", s = "_isCondensed_1pgra_14", i = "_isHugging_1pgra_17", t = "_withCTA_1pgra_20", g = {
  container: n,
  isCondensed: s,
  isHugging: i,
  withCTA: t
};
export {
  n as container,
  g as default,
  s as isCondensed,
  i as isHugging,
  t as withCTA
};
//# sourceMappingURL=index.es5580.js.map
